import { useState } from "react";
import { wallPosts } from "@/mocks/gossip";
import { contactEmail } from "@/mocks/gossip";

const colorRing = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
  "bg-background-300 text-foreground-700",
];

export default function Plaza() {
  const [posts, setPosts] = useState(() =>
    wallPosts.map((p) => ({ ...p, liked: false }))
  );

  const toggleLike = (id: string) => {
    setPosts((prev) =>
      prev.map((p) =>
        p.id === id
          ? { ...p, liked: !p.liked, likes: p.likes + (p.liked ? -1 : 1) }
          : p
      )
    );
  };

  return (
    <section id="plaza" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
            <i className="ri-chat-3-fill"></i> 吃瓜广场
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            围观唠嗑 · 校园吃瓜爆料墙
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-500">
            匿名的围观与讨论都在这里，理性吃瓜、友善发言，给每条瓜点个赞吧。
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          <div className="grid gap-4 lg:col-span-2">
            {posts.map((p, i) => (
              <article
                key={p.id}
                className="rounded-2xl border border-background-200 bg-background-50 p-4 shadow-soft md:p-5"
              >
                <div className="flex items-start gap-3">
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold ${colorRing[i % 4]}`}
                  >
                    {p.name.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold text-foreground-900">
                          {p.name}
                        </span>
                        <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] text-foreground-600">
                          {p.tag}
                        </span>
                      </div>
                      <time className="text-xs text-foreground-400">{p.time}</time>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                      {p.content}
                    </p>
                    <div className="mt-3 flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => toggleLike(p.id)}
                        aria-pressed={p.liked}
                        className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition ${
                          p.liked
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
                        }`}
                      >
                        <i
                          className={`${p.liked ? "ri-heart-fill" : "ri-heart-line"}`}
                        ></i>
                        {p.likes}
                      </button>
                      <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600">
                        <i className="ri-chat-3-line"></i>
                        {p.comments}
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* 投稿侧栏 */}
          <aside className="space-y-4">
            <div className="rounded-2xl bg-foreground-950 p-6 text-background-100">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                <i className="ri-upload-2-line"></i> 投稿上墙
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold text-background-50">
                你有瓜想让大家围观？
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200">
                把身边的新鲜事、名场面或暖闻写成几句悄悄话投给我们，求证后就能上吃瓜墙。
              </p>
              <div className="mt-5 space-y-2 rounded-xl bg-background-50/10 p-4 text-xs leading-relaxed">
                <p className="flex gap-2 text-background-200">
                  <i className="ri-shield-check-line text-accent-300"></i>
                  投稿支持匿名，隐私信息会自动打码
                </p>
                <p className="flex gap-2 text-background-200">
                  <i className="ri-checkbox-circle-line text-accent-300"></i>
                  内容先求证后发布，拿不准的会标注待核实
                </p>
              </div>
              <a
                href={`mailto:${contactEmail}`}
                className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-3 text-sm font-medium text-background-50 transition hover:bg-accent-600"
              >
                <i className="ri-mail-send-line"></i>
                发邮件投稿
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}